import {
  Breadcrumbs as MantineBreadcrumbs,
  BreadcrumbsProps as MantineBreadcrumbsProps,
} from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';

import { Link } from '../Link';
import styles from './Breadcrumbs.module.css';

export type BreadcrumbItem = {
  href: string;
  title: string;
  masked?: boolean;
};

export interface BreadcrumbsProps extends Omit<
  MantineBreadcrumbsProps,
  'children' | 'styles' | 'classNames' | 'style'
> {
  items: BreadcrumbItem[];
}

export const Breadcrumbs = ({ items, ...props }: BreadcrumbsProps) => {
  return (
    <MantineBreadcrumbs
      unstyled
      classNames={{
        root: styles.root,
        separator: styles.separator,
        breadcrumb: styles.breadcrumb,
      }}
      separator={<IconChevronRight size={20} stroke={1.5} />}
      {...props}
    >
      {items.map((item, index) => {
        const isCurrent = index === items.length - 1;
        const key = `${item.href}-${index}`;

        // The current (last) crumb is the page you are already on - per design it
        // is plain text, not a link: darker color, no hover treatment.
        if (isCurrent) {
          return (
            <span
              key={key}
              aria-current="page"
              className={`${styles.current} ${item.masked ? 'fs-mask' : ''}`}
            >
              {item.title}
            </span>
          );
        }

        return (
          <Link
            key={key}
            href={item.href}
            variant="stepper"
            isMasked={item.masked}
            className={styles.link}
          >
            {item.title}
          </Link>
        );
      })}
    </MantineBreadcrumbs>
  );
};
